
const apiConfig = {
    //Local
   // apiUrl: 'https://localhost:7268/api/',
    //Live

    //DEV
    apiUrl: 'https://at-api.solegaze.com/api/',
    apiKey: 'Lieda1002',
};

export default apiConfig;

